import React from 'react';
import { makeStyles } from '@mui/styles';
import {
  Container,
  Typography,
  Avatar
} from '@mui/material';

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(5, 0, 4),
    minHeight: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  heroContent: {
    textAlign: 'center',
  },
  avatar: {
    width: theme.spacing(14),
    height: theme.spacing(14),
    margin: '0 auto',
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.secondary.main,
    fontSize: '2rem',
    fontWeight: 'bold',
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  description: {
    fontSize: '1.2rem',
    maxWidth: '800px',
    margin: '0 auto',
    lineHeight: 1.6,
    color: theme.palette.primary.contrastText,
  },
}));

const HeroSection = () => {
  const classes = useStyles();

  return (
    <section className={classes.heroSection}>
      <Container maxWidth="lg">
        <div className={classes.heroContent}>
          <Avatar
            className={classes.avatar}
            src="/503229720_122120607614842262_7867287881405528820_n.jpg"
            alt="Ameet Toor"
          >
            AT
          </Avatar>

          <Typography variant="h1" className={classes.title}>
            Ameet Toor
          </Typography>

          <Typography variant="body1" className={classes.description}>
            Computer science is magic, it gives us the tools to make anything into reality. We are only limited by our imagination and skill.
          </Typography>
        </div>
      </Container>
    </section>
  );
};

export default HeroSection;
